export default __webpack_public_path__ + "static/vedica-7d8c063b80543b6ae3c33374501f4611.png";